import CookieDb from './index.js';
class Favorite extends CookieDb {
    defaults() {
        return {
            apiPath: '/api/favorite',
            cookieKeyName: 'favorites',
            expires: 2, // 2日間有効
            secure: location.protocol === 'https:',
        };
    }
}

export default Favorite;
